import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const CREATE_CRITICAL_UPDATE_PATH =
    '/dashboard/systemadmin/create-critical-organization-updates';
export const VIEW_CRITICAL_UPDATE_PATH =
    '/dashboard/systemadmin/view-critical-organization-updates';
export const UPDATE_CRITICAL_UPDATE_PATH =
    '/dashboard/systemadmin/update-critical-organization-updates';

export type CriticalUpdatesTab = 'create' | 'update';

export const CriticalOrganizationUpdatesTabs: React.FC<{
    active: CriticalUpdatesTab;
}> = ({ active }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const text = (key: string, defaultValue: string) =>
        t(`SystemAdmin.CriticalOrganizationUpdates.${key}`, { defaultValue });
    const isCreate = active === 'create';

    return (
        <div className='critical-updates__tabs' role='tablist'>
            <button
                className={`critical-updates__tab ${
                    isCreate ? 'is-active' : ''
                }`}
                type='button'
                role='tab'
                aria-selected={isCreate}
                onClick={() =>
                    !isCreate && navigate(CREATE_CRITICAL_UPDATE_PATH)
                }
            >
                {text('CreateTab', 'Create Critical Organization Updates')}
            </button>
            <button
                className={`critical-updates__tab ${
                    !isCreate ? 'is-active' : ''
                }`}
                type='button'
                role='tab'
                aria-selected={!isCreate}
                onClick={() => isCreate && navigate(VIEW_CRITICAL_UPDATE_PATH)}
            >
                {text('UpdateTab', 'Update Critical Organization Updates')}
            </button>
        </div>
    );
};
